<template>
  <v-btn
    v-if="isNewDeviceProcess"
    class="mbtn font-weight-regular"
    prepend-icon="ct:arrow-left"
    @click="buyoutStore.mainBuyoutStep -= 1"
  >
    {{ t("buyout.appraisal.go_back") }}
  </v-btn>
  <div
    id="productSelector"
    :class="['bPicker', !componentProps.isBuyoutProcess ? 'bPicker--lp extendedBg' : '']"
    :style="'--ct-category-counter: ' + categoryCounter"
  >
    <h1 :class="['app__title mt-0', !isBuyoutProcess ? 'app__title--h2 text-center' : 'app__title--h3']">
      {{ isBuyoutProcess ? getDeviceTypeText : t("static.banners.evaluate_device") }}
    </h1>

    <client-only>
      <v-progress-circular v-if="loadingAvailableDeviceTypes" />
      <div :class="[!isBuyoutProcess ? 'display-contents' : 'buyout__cards']">
        <div
          v-for="deviceType in availableDeviceTypes"
          :key="deviceType.id"
          :class="[
            !isBuyoutProcess ? '' : 'bCard', 'bPicker__category',
            selectedDeviceType === deviceType && isBuyoutProcess ? 'is-selected' : '',
            'cursor-pointer'
          ]"
          @click="selectDeviceType(deviceType)"
        >
          <img :src="deviceImage(deviceType)" class="img-responsive">
          <div class="bPicker__desc font-weight-semibold first-letter-uppercase">
            {{ deviceType.name_singular ? deviceType.name_singular : deviceType.name }}
          </div>
          <div
            v-if="!isBuyoutProcess"
            class="mbtn--rectangle mbtn--greenInv font-weight-semibold"
          >
            {{ t("static.products.calculate_price") }}
          </div>
        </div>
      </div>
    </client-only>
    <!--    Phase 2-->
    <template v-if="isBuyoutProcess && false">
      <div class="app__title app__title--h5 font-poppins">
        {{ t("form.common.or_search_for_a_device_by_name") }}
      </div>
      <div class="app__form">
        <div class="formItem formItem--1x6 formItem--noLabel">
          <v-autocomplete
            clearable
            :placeholder="t('buyout.appraisal.fast_model_search')"
          >
            dd
          </v-autocomplete>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

const localePath = useLocalePath();
const { t } = useI18n();
const buyoutStore = useBuyoutStore();
const bonusPartnerWithManufacturerBuyoutStore = useBonusPartnerWithManufacturerBuyoutStore();
const { locale } = useI18n();
const config = useRuntimeConfig();

// const getBuyoutPathByLanguage = computed<string>(() => {
//   // ToDo add translation
// });

const {
  selectedDeviceType, appraisalBuyoutStep, availableDeviceTypes, loadingAvailableDeviceTypes
} = storeToRefs(buyoutStore);

const componentProps = withDefaults(defineProps<{
  isBuyoutProcess?: boolean
  isNewDeviceProcess?: boolean
}>(), {
  isBuyoutProcess: true,
  isNewDeviceProcess: false
});

if (!availableDeviceTypes.value.length) {
  buyoutStore.loadAvailableDeviceTypes();
}

watch(locale, () => {
  buyoutStore.loadAvailableDeviceTypes();
});

const getDeviceTypeText = computed(() => {
  return componentProps.isNewDeviceProcess ? t("static.banners.choose_device_type_for_buyout") : t("static.banners.choose_device_type");
});

const categoryCounter = computed(() => {
  if (availableDeviceTypes.value.length > 5) {
    return 5;
  }
  return availableDeviceTypes.value.length;
});

function selectDeviceType (deviceType: BuyoutDeviceType) {
  if (componentProps.isBuyoutProcess && selectedDeviceType.value !== deviceType) {
    selectedDeviceType.value = deviceType;
    buyoutStore.resetManufacturer();
    if(componentProps.isNewDeviceProcess){
      bonusPartnerWithManufacturerBuyoutStore.changeURLNewDevice();
    } else {
      buyoutStore.changeURL();
    }
  }
  appraisalBuyoutStep.value += 1;
  if (!componentProps.isBuyoutProcess) {
    navigateTo(localePath({ name: "buyout-type-manufacturer-meta_master-variant-color-quality", params: { type: deviceType.seo_name }, query: { refId: buyoutStore.getBuyoutReferralId() } }));
  }
}

function deviceImage (deviceType: BuyoutDeviceType): string {
  const devices = {
    telefony: "category-phone.jpg",
    tablety: "category-tablet.jpg",
    "chytre-hodinky": "category-smartwatch.jpg",
    notebooky: "category-laptop.jpg",
    gaming: "category-console.jpg",
    foto: "category-camera.jpg",
    "foto-objektivy": "category-lens.jpg",
    reproduktory: "category-audio.jpg",
  };
  const image = devices[deviceType?.identifier as keyof typeof devices] || "category-phone.jpg";
  return `${config.app.baseURL}/img/category/${image}`.replace(/\/\//g, "/");
}
</script>
